import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import NavigateBackButton from '@/common/components/NavigateBackButton'
import { EventForm, FormValues as CustomFormValues } from '../EventForm'
import {
	TurnoverEventForm,
	FormValues as TurnoverFormValues,
} from '../TurnoverEventForm'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateEvent from '@/modules/events/api/hooks/useMutationCreateEvent'
import { useQueryClient } from '@tanstack/react-query'
import { EventsQueryKeys } from '@/modules/events/keys'
import { createTurnoverEvent } from '../../api/services'
import type { EventType } from '../../type'

export default function CreateEventListing() {
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const [searchParams] = useSearchParams()
	const eventType = (searchParams.get('type') || 'CUSTOM') as EventType

	const createEventMutation = useMutationCreateEvent({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [EventsQueryKeys.getEvents],
			})
			toast.success('สร้างกิจกรรมสำเร็จ')
			navigate('/operator/events')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleCustomEventSubmit = (values: CustomFormValues) => {
		createEventMutation.mutate({
			...values,
			bannerUrl: values.bannerUrl || undefined,
			shortDescription: values.shortDescription || undefined,
			description: values.description || undefined,
			linkUrl: values.linkUrl || undefined,
			isActive: true,
		})
	}

	const handleTurnoverEventSubmit = async (values: TurnoverFormValues) => {
		try {
			await createTurnoverEvent(values as any)
			queryClient.invalidateQueries({
				queryKey: [EventsQueryKeys.getTurnoverEvents],
			})
			toast.success('สร้างกิจกรรม Turnover สำเร็จ')
			navigate('/operator/events')
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	const title =
		eventType === 'TURNOVER' ? 'สร้างกิจกรรมเทิร์นโอเวอร์' : 'สร้างกิจกรรม'
	const description =
		eventType === 'TURNOVER'
			? 'สร้างกิจกรรมรางวัลตามยอดเทิร์นโอเวอร์'
			: 'สร้างกิจกรรมใหม่สำหรับแสดงบนเว็บไซต์'

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={title} description={description} />
				<NavigateBackButton />
			</div>
			<Separator />
			{eventType === 'TURNOVER' ? (
				<TurnoverEventForm onSubmit={handleTurnoverEventSubmit} mode="create" />
			) : (
				<EventForm onSubmit={handleCustomEventSubmit} mode="create" />
			)}
		</div>
	)
}
